import { render } from "./MenuRenderer.vue?vue&type=template&id=738afa40&lang=html"
import script from "./MenuRenderer.vue?vue&type=script&lang=js"
export * from "./MenuRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__